<template>
  <div class="d-bar">
    <bar></bar>
  </div>
  <div class="container-xl">
    <div class="row designer justify-content-evenly d-none d-sm-none d-md-flex">
      <div class="col-xl-4 col-sm-5">
        <!-- <div class="col-3"> -->
        <div class="pt-2">
          <button class="btn btn-outline-lcn me-2" @click="gotoList">
            <font-awesome-icon
              :icon="['fas', 'angle-left']"
              class="icon"
            ></font-awesome-icon>
            {{ t("message.backToProjOverview") }}
          </button>
          <button
            v-if="inlaySave.length > 1"
            class="btn btn-outline-lcn"
            @click="undo()"
          >
            <font-awesome-icon
              :icon="['fas', 'undo']"
              class="icon"
            ></font-awesome-icon>
            {{ t("message.undo") }}
          </button>
        </div>
        <editor></editor>
      </div>
      <div class="col-7"><DesignerContent></DesignerContent></div>
    </div>
  </div>
</template>

<script>
import DesignerContent from "./content/DesignerContent";
import Editor from "./designer/DesignerEditor";
import Bar from "./designer/DesignerBar.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { computed, onMounted } from "vue";

export default {
  name: "Designer",
  setup() {
    onMounted(() => {
      window.addEventListener("beforeunload", (event) => {
        event.preventDefault();
        // Chrome requires returnValue to be set.
        return (event.returnValue =
          "Do you really want to leave? you have unsaved changes!");
      });
    });
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();
    const inlaySave = computed(() => store.getters.inlaySave);
    function undo() {
      store.dispatch("undoSaveInlay");
    }
    function gotoList() {
      store.commit("updateProjectInlay");
      store.commit("emptySaveInlay");
      store.commit("selectBtns", []);
      router.push("/list");
    }
    return { router, undo, t, gotoList, inlaySave };
  },
  components: {
    Editor,
    DesignerContent,
    Bar,
  },
};
</script>

<style lang="scss" scoped>
.d-bar {
  // height: 50px;
  // padding: 10px;
  background-color: #fff;
  line-height: 30px;
}
.designer {
  background-color: #fff;
  // width: 1100px;
  margin: auto;
  // height: calc(100vh - 200px);
}
</style>
